import type { ModeT } from '../types';

export type VisualizationState =
  | 'hide-answers'
  | 'view-answers'
  | 'start-voting'
  | 'view-results'
  | 'view-correct-answer'
  | 'editor-empty'
  | undefined;

const visualizationStates: VisualizationState[] = [
  'hide-answers',
  'view-answers',
  'start-voting',
  'view-results',
  'view-correct-answer',
  'editor-empty',
];

interface GetVisualizationStateProps {
  currentStep: string | undefined;
  mode: ModeT;
  votingOnAnswers?: boolean;
  numberOfAnswers?: number;
}

export const getVisualizationState = ({
  currentStep,
  mode,
  votingOnAnswers,
  numberOfAnswers,
}: GetVisualizationStateProps): VisualizationState => {
  // Public or screenshot mode always shows final results
  if (mode === 'public' || mode === 'screenshot') {
    return votingOnAnswers ? 'view-results' : 'view-answers';
  }

  // Editor mode
  if (mode === 'idle') {
    if (numberOfAnswers === 0) {
      return 'editor-empty';
    }
    if (votingOnAnswers) {
      return 'view-results';
    } else {
      return 'view-answers';
    }
  }

  if (visualizationStates.includes(currentStep as VisualizationState)) {
    return currentStep as VisualizationState;
  }

  return undefined;
};
